import { TextField, styled } from "@mui/material";

const InputCustom = styled(TextField)(({ theme }) => ({
  "label + &": {
    marginTop: "1.5rem", // 24px
    marginBottom: 0,
  },
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
    borderRadius: "0.25rem", // 4px
    border: "1px solid #E8DFD7",
  },
  "& .MuiInputBase-root .MuiInputBase-input": {
    position: "relative",
    fontSize: "0.8125rem", // 13px
    padding: "0.6875rem 0.75rem", // 11px 12px
    caretColor: theme.palette.primary.main,
  },
  "& .MuiFormHelperText-root": {
    marginLeft: "0",
    marginBottom: "-0.625rem", // -10px
  },
  "& .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: theme.palette.sand.main,
    opacity: 0.7,
  },
  "& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "& .MuiInputBase-root.Mui-disabled .MuiInputBase-input": {
    color: theme.palette.gray.dark,
    WebkitTextFillColor: theme.palette.gray.dark,
  },
  "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWidth: "0.0625rem", // 1px
    border: `0.0625rem solid ${theme.palette.primary.main}`, // 1px solid
  },
  "& .MuiInputBase-root.Mui-error": {
    borderRadius: "0.5rem", // 8px
    backgroundColor: theme.palette.error.light,
  },
  "& .MuiInputBase-root.Mui-error input": {
    borderRadius: "0.5rem", // 8px
    backgroundColor: theme.palette.error.light,
  },
  "& .MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    border: `0.0625rem solid ${theme.palette.error.main}`, // 1px solid
  },
  "& .MuiInputBase-root .MuiInputBase-inputMultiline": {
    padding: 0,
  },
}));

export default InputCustom;
